import type { FaireProductEntity } from "../../entity_types/product";

export const p_hrv24hbv9q: FaireProductEntity = {
  token: "p_hrv24hbv9q",
  type: "product",
  name: "Are You Fucking Kidding Me Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/0f4b799e3dfa1c7fdfbe155e49348bbe7fd6cd23dc174861184bd6f22b4017da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4592ca010bf1842fa277e870afdbe177add4e0636a2a3531246ced70017f6fd6.jpeg",
    "https://cdn.faire.com/fastly/b22359f29d9764c0fddc41cdce96fe8e8beff3ac045dc5a8b82cc2f90f19c2a9.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/0b74fb77f3c311914d2a254efae9f8ac54f4ea739dedd6c3524b3123ebb42674.jpeg",
    "https://cdn.faire.com/fastly/d623dfaaaeef08bb0f7879b9446cd6fad332950cefa576189c34240e5c5146d9.jpeg"
  ],
  priceDollars: 6.75,
  description: "When words just aren’t enough. These socks say exactly what you’re thinking without you having to do the legwork.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:10.815Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
